// extracted by mini-css-extract-plugin
export var statItem = "_ir-1";
export var statsRow = "_ir-0";